import { FC } from "react";
import Toast from "./Toast";
import { ArkToaster, CreateToasterReturn, ToastProps } from "./toast-parts";

interface ToasterProps {
  toaster: CreateToasterReturn;
}

export const Toaster: FC<ToasterProps> = ({ toaster }) => {
  return (
    <ArkToaster toaster={toaster}>
      {(toast) => <Toast toast={toast as ToastProps} />}
    </ArkToaster>
  );
};
